/** Written by hand: the name of the enum generated for `lang` depends on how the backend describes it. */
export const Lang = {
  De: 'de',
  Es: 'es',
  En: 'en',
  Fr: 'fr',
  It: 'it',
  Pt: 'pt',
} as const;

export type Lang = (typeof Lang)[keyof typeof Lang];
